import _toConsumableArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { camelCase, upperFirst } from 'es-toolkit/string';
import { LANGUAGES } from 'docs/config';
export function pascalCase(str) {
  return upperFirst(camelCase(str));
}
function titleize(hyphenedString) {
  return upperFirst(hyphenedString.split('-').join(' '));
}
export function pageToTitle(page) {
  if (page.title === false) {
    return null;
  }
  if (page.title) {
    return page.title;
  }
  var path = page.subheader || page.pathname;
  var name = path.replace(/.*\//, '').replace('react-', '').replace(/\..*/, '');

  // TODO remove post migration
  if (path.includes('/api-docs/')) {
    return pascalCase(name);
  }

  // TODO support more than React component API (PascalCase)
  if (path.includes('/api/')) {
    return name.startsWith('use') ? camelCase(name) : pascalCase(name);
  }
  return titleize(name);
}
export function pageToTitleI18n(page, t) {
  var path = page.subheader || page.pathname;
  return page.query ? pageToTitle(page) : t("pages.".concat(path), {
    ignoreWarning: true
  }) || pageToTitle(page);
}

/**
 * Get the value of a cookie
 * Source: https://vanillajstoolkit.com/helpers/getcookie/
 * @param name - The name of the cookie
 * @return The cookie value
 */
export function getCookie(name) {
  if (typeof document === 'undefined') {
    throw new Error('getCookie() is not supported on the server. Fallback to a different value when rendering on the server.');
  }
  var value = "; ".concat(document.cookie);
  var parts = value.split("; ".concat(name, "="));
  if (parts.length === 2) {
    return parts[1].split(';').shift();
  }
  return undefined;
}

/**
 * as is a reference to Next.js's as, the path in the URL
 * pathname is a reference to Next.js's pathname, the name of page in the filesystem
 * https://nextjs.org/docs/api-reference/next/router
 */
export function pathnameToLanguage(pathname) {
  var userLanguage;
  var userLanguageCandidate = pathname.substring(1, 3);
  if ([].concat(_toConsumableArray(LANGUAGES), ['zh']).includes(userLanguageCandidate) && pathname.startsWith("/".concat(userLanguageCandidate, "/"))) {
    userLanguage = userLanguageCandidate;
  } else {
    userLanguage = 'en';
  }
  var canonicalAs = userLanguage === 'en' ? pathname : pathname.substring(3);
  // Remove hash as it's never sent to the server
  // https://github.com/vercel/next.js/issues/25202
  var canonicalAsServer = canonicalAs.replace(/#(.*)$/, '');
  var canonicalPathname = canonicalAsServer.replace(/^\/api/, '/api-docs');

  // Remove trailing slash as Next.js doesn't expect it here
  // https://nextjs.org/docs/pages/api-reference/functions/use-router#router-object
  if (canonicalPathname !== '/') {
    canonicalPathname = canonicalPathname.replace(/\/$/, '');
  }
  return {
    userLanguage: userLanguage,
    canonicalAs: canonicalAs,
    canonicalAsServer: canonicalAsServer,
    canonicalPathname: canonicalPathname
  };
}